import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import Button from 'components/Button';
import {device} from 'styled/device';

export const StyledAddressSection = styled.div`
  display: flex;
  flex-direction: column;

  .title {
    color: #23262f;
    font-weight: 600;
    font-size: 32px;
    padding-bottom: 30px;
  }

  .addressTitle {
    color: #777e91;
    font-weight: 500;
    font-size: 18px;
  }

  .addressText {
    color: #777e91;
    font-weight: 400;
    font-size: 18px;
    padding: 20px 0 30px 0;
  }

  @media (max-width: ${device.mobileM}) {
    .title {
      font-size: 24px;
    }
  }
`;

export type AddressSectionProps = {
  address: string;
};

function AddressSection({address}: AddressSectionProps) {
  const {t} = useTranslation();

  return (
    <StyledAddressSection>
      <div className="title">{t('address')}</div>
      <div className="addressTitle">Charitépl</div>
      <div className="addressText">{address}</div>
      <Link
        to={{
          pathname: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            address,
          )}`,
        }}
        target="_blank"
      >
        <Button label={t('view_map')} iconRight="mapMark" />
      </Link>
    </StyledAddressSection>
  );
}

export default AddressSection;
